function firstNav() {
    const togglerAriaPressed = document.getElementById('toggleMenu');
    let isMobile = window.innerWidth < 990;

    if (togglerAriaPressed) {

        const navItems = document.querySelectorAll(".first-area-item");
        const navItemWrapper = document.querySelector(".nav-first-area");
        const toggleBtn = document.getElementById('toggleMenu').querySelector('i');
        const myModalEl = document.getElementById('firstnav');

        isMobile = window.innerWidth < 990;

        function toggleBtnNavModal() {

            if (toggleBtn.classList.contains('icon-burger')) {
                togglerAriaPressed.setAttribute("aria-pressed", "true");
                toggleBtn.classList.remove('icon-burger');
                toggleBtn.classList.add('icon-plus');
            } else {
                togglerAriaPressed.setAttribute("aria-pressed", "false");
                toggleBtn.classList.remove('icon-plus');
                toggleBtn.classList.add('icon-burger');
            }
        }

        myModalEl.addEventListener('hidden.bs.modal', toggleBtnNavModal);
        myModalEl.addEventListener('show.bs.modal', toggleBtnNavModal);

        // Platzhalter am Ende des Modals, der zum Toggle-Button redirected
        myModalEl.setAttribute('data-bs-focus', 'false');
        const sentinel = document.createElement('span');
        sentinel.tabIndex = 0;
        sentinel.className = 'visually-hidden';
        sentinel.textContent = 'Menü schließen';
        sentinel.addEventListener('focus', () => togglerAriaPressed.focus());
        myModalEl.querySelector('.modal-body')?.appendChild(sentinel);

        function resetMenu() {
            navItemWrapper?.removeAttribute("style");

            document.querySelectorAll(".nav-second-area").forEach((subMenu) => {
                subMenu.removeAttribute("style");
                subMenu.classList.add("d-none");
            });

            navItems.forEach((item) => {
                item.classList.remove("active");

                const link = item.querySelector('.nav-link');
                const sub = item.querySelector('.nav-second-area');

                if (link && sub) {
                    link.setAttribute("aria-expanded", "false");
                } else if (link) {
                    link.removeAttribute("aria-expanded");
                }
            });
        }

        let resizeTimer;

        // Mobile/Tablet-Drehung
        window.addEventListener("orientationchange", () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(() => {
                resetMenu();

                const navWrapper = document.querySelector(".nav-first-area");
                if (navWrapper) {
                    navWrapper.innerHTML = navWrapper.innerHTML;
                }

                const toggleBtn = document.getElementById('toggleMenu').querySelector('i');
                const togglerAriaPressed = document.getElementById('toggleMenu');
                const myModalEl = document.getElementById('firstnav');

                function toggleBtnNavModal() {
                    if (toggleBtn.classList.contains('icon-burger')) {
                        togglerAriaPressed.setAttribute("aria-pressed", "true");
                        toggleBtn.classList.remove('icon-burger');
                        toggleBtn.classList.add('icon-plus');
                    } else {
                        togglerAriaPressed.setAttribute("aria-pressed", "false");
                        toggleBtn.classList.remove('icon-plus');
                        toggleBtn.classList.add('icon-burger');
                    }
                }

                myModalEl.removeEventListener('hidden.bs.modal', toggleBtnNavModal);
                myModalEl.removeEventListener('show.bs.modal', toggleBtnNavModal);
                myModalEl.addEventListener('hidden.bs.modal', toggleBtnNavModal);
                myModalEl.addEventListener('show.bs.modal', toggleBtnNavModal);

                firstNav();
            }, 200);
        });


        // DESKTOP-NAVIGATION
        if (!isMobile) {
            navItems.forEach((item) => {
                const subMenu = item.querySelector(".nav-second-area");
                const link = item.querySelector(".nav-link");

                function showCurrentSubMenu() {
                    document.querySelectorAll(".nav-second-area").forEach((menu) => {
                        menu.classList.remove("d-inline-block");
                        menu.classList.add("d-none");
                    });

                    document.querySelectorAll(".first-area-item").forEach((el) => {
                        el.classList.remove("active");
                        const l = el.querySelector(".nav-link");
                        const s = el.querySelector(".nav-second-area");

                        if (l && s) {
                            l.setAttribute("aria-expanded", "false");
                        } else if (l) {
                            l.removeAttribute("aria-expanded");
                        }
                    });

                    if (subMenu) {
                        subMenu.classList.add("d-inline-block");
                        subMenu.classList.remove("d-none");
                    }

                    item.classList.add("active");

                    if (link && subMenu) {
                        link.setAttribute("aria-expanded", "true");
                    } else if (link) {
                        link.removeAttribute("aria-expanded");
                    }
                }

                function hideCurrentSubMenu() {
                    if (subMenu) {
                        subMenu.classList.remove("d-inline-block");
                        subMenu.classList.add("d-none");
                    }
                    item.classList.remove("active");

                    if (link && subMenu) {
                        link.setAttribute("aria-expanded", "false");
                    } else if (link) {
                        link.removeAttribute("aria-expanded");
                    }
                }

                link?.addEventListener("click", (e) => {
                    if (subMenu) {
                        e.preventDefault();
                        if (item.classList.contains("active")) {
                            hideCurrentSubMenu();
                        } else {
                            showCurrentSubMenu();
                        }
                    }
                });
                link?.addEventListener('keydown', (e) => {
                    if (e.keyCode === 13 || e.code === "Enter") {
                        if (subMenu) {
                            e.preventDefault();
                            if (item.classList.contains("active")) {
                                hideCurrentSubMenu();
                            } else {
                                showCurrentSubMenu();
                            }
                        }
                    }
                });
                item.addEventListener("focusout", function (e) {
                    if (!item.contains(e.relatedTarget)) {
                        hideCurrentSubMenu();
                    }
                });
                document.addEventListener("click", (e) => {
                    if (!item.contains(e.target)) {
                        hideCurrentSubMenu();
                    }
                });
            });

        } else {
            // MOBIL-NAVIGATION
            myModalEl.addEventListener('hidden.bs.modal', resetMenu);

            navItems.forEach((item) => {
                const trigger = item.querySelector(".nav-link");
                const subMenu = item.querySelector(".nav-second-area");
                const btnBack = item.querySelector(".btn-back button");

                function openSubMenu() {
                    if (!isMobile || !subMenu) return;

                    resetMenu();

                    navItemWrapper.style.transform = "translateX(-110%)";
                    subMenu.style.transform = "translateX(110%)";
                    subMenu.style.left = "0";
                    subMenu.classList.remove("d-none");
                    subMenu.classList.add("d-inline-block");
                    item.classList.add("active");

                    if (trigger) {
                        trigger.setAttribute("aria-expanded", "true");
                    }

                    // Nach oben scrollen im Modal
                    const modalBody = myModalEl.querySelector('.modal-body');
                    if (modalBody) {
                        modalBody.scrollTop = 0;
                    }
                }

                function closeSubMenu() {
                    resetMenu();
                    if (trigger) {
                        trigger.setAttribute("aria-expanded", "false");
                    }
                }

                trigger?.addEventListener("click", (e) => {
                    if (isMobile) {
                        e.preventDefault();
                        openSubMenu();
                    }
                });

                trigger?.addEventListener('keydown', (e) => {
                    if (e.keyCode === 13 && isMobile) {
                        openSubMenu();
                    }
                });

                btnBack?.addEventListener("click", (e) => {
                    e.preventDefault();
                    closeSubMenu();
                });

                btnBack?.addEventListener('keydown', (e) => {
                    if (e.keyCode === 13) {
                        e.preventDefault();
                        closeSubMenu();
                    }
                });
            });
        }
    }
}

export default firstNav;
